"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateNeg90Degrees = void 0;
/**
* Returns a negative 90 degrees rotated version of the given 2-vector.
* @param p a 2d vector
*/
function rotateNeg90Degrees(p) {
    return [p[1], -p[0]];
}
exports.rotateNeg90Degrees = rotateNeg90Degrees;
//# sourceMappingURL=rotate-neg-90-degrees.js.map